var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contenedor-cpanel"},[_c('section',{staticClass:"contenedor-c"},[_vm._m(0),_c('ServiciosImpagosLista')],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contenedor-titulo"},[_c('h1',[_vm._v("Servicio Impago")]),_c('div',{staticClass:"barra"})])
}]

export { render, staticRenderFns }